/*
 * @Author: Dong
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-10 17:38:43
 */
import React, { useState } from 'react';

import welcomeImg from 'root/assets/images/illustrator_welcome.png';
import styles from '../index.less';
import InitNoDataPage from 'root/pages/PackageManage/components/InitNoDataPage';

const Welcome = () => {
  const [refresh, setRefresh] = useState(false);

  return (
    <div className={styles.welcomeContainer}>
      <img src={welcomeImg} className={styles.welcomeImg} />
      <InitNoDataPage refresh={refresh} setRefresh={setRefresh} />
    </div>
  );
};

export default Welcome;
